(function() {

    'use strict';



    var VAST = SAPO.Project.Video.VAST;
    var arrIndexOf = SAPO.Utility.arrIndexOf;



    var js = function(o) { return JSON.stringify(o); };
    // var log = function() { window.console.log.apply(window.console, arguments); };
    var log = function() {};



    var mimeTypes = [
        'text/javascript',
        'application/javascript',
        'application/x-shockwave-flash'
    ];



    var events = 'AdClickThru AdError AdExpandedChange AdImpression AdLinearChange AdLoaded AdLog AdPaused AdPlaying AdRemainingTimeChange AdStarted AdStopped AdUserAcceptInvitation AdUserClose AdUserMinimize AdVideoComplete AdVideoFirstQuartile AdVideoMidpoint AdVideoStart AdVideoThirdQuartile AdVolumeChange AdDurationChange AdInteraction AdSizeChange AdSkipped AdSkippableStateChange'.split(' ');

    var onEvent = function(ev) {
        //log('*onEvent:', ev);

        switch (ev.type) {
            case 'AdStarted':
                log('AdStarted:');
                log('  getAdLinear() -> ' + js(this.getAdLinear()) );
                if (this.getAdLinear()) {
                    log('  getAdRemainingTime() -> ' + this.getAdRemainingTime().toFixed(2) );
                }
                break;

            case 'AdLog':
                log('AdLog: ' + ev.data.message);
                break;

            case 'AdRemainingTimeChange':
                log('AdRemainingTimeChange:');
                log('  getAdRemainingTime() -> ' + this.getAdRemainingTime().toFixed(2) );
                break;

            case 'AdExpandedChange:':
                log('AdExpandedChange:');
                log('  getAdExpanded() -> ' + js(this.getAdExpanded()));
                break;

            case 'AdVolumeChange':
                log('AdVolumeChange:');
                log('  getAdVolume() -> ' + js(this.getAdVolume()));
                break;

            case 'AdLinearChange':
                log('AdLinearChange:');
                log('  getAdLinear() -> ' + js(this.getAdLinear()));
                break;

            case 'AdClickThru':
                log('AdClickThru:');
                log('AdClickThru: ' + js(ev.data));
                break;

            case 'AdSizeChange':
                log('AdSizeChange:');
                log('  getAdWidth()  -> ' + this.getAdWidth() );
                log('  getAdHeight() -> ' + this.getAdHeight());
                break;

            case 'AdDurationChange':
            case 'AdError':
            case 'AdImpression':
            case 'AdInteraction':
            case 'AdLoaded':
            case 'AdPaused':
            case 'AdPlaying':
            case 'AdSizeChange': // TODO USE THIS
            case 'AdSkipped':
            case 'AdSkippableStateChange':
            case 'AdStopped':
            case 'AdVideoComplete':
            case 'AdVideoFirstQuartile':
            case 'AdVideoStart':
            case 'AdVideoMidpoint':
            case 'AdVideoThirdQuartile':
            case 'AdUserAcceptInvitation':
            case 'AdUserClose':
            case 'AdUserMinimize':
                if (ev.data) {
                    log(ev.type + ':' + js(ev.data));
                }
                else {
                    log(ev.type);
                }
                break;

            default:
                log('IGNORED type:"' + ev.type + '"');
        }
    };



    function AdUnitBuilder(item, parentEl, cb) {
        var impl = VAST.VPAID[ 'AdWrapper' + ( (item.implName === 'flash') ? 'Flash' : 'Html5') ];

        var o = {
            adURL:     item.src,
            adDims:    item.dims,
            container: parentEl,
            onReady:   function(aw) {
                //console.log('onReady', aw);

                var onEvent2 = onEvent.bindObj(aw);
                events.forEach(function(evName) { // TODO FOREACH
                    aw.subscribe(onEvent2, evName);
                });

                if (cb) {
                    cb(aw);
                }
            }
        };

        if (!('viewMode' in o)) {
            o.viewMode = 'normal';
        }

        if (!('creativeData' in o)) {
            o.creativeData = ( (item.implName === 'flash') ? '' : {});
        }

        if (!('environmentVars' in o)) {
            o.environmentVars = ( (item.implName === 'flash') ? '' : {});
        }

        impl(o);
    }



    function AdUnitHdlr(item) {

        if (
            item.nodeName !== 'MediaFile' ||
            arrIndexOf(mimeTypes, item.type) === -1          /*||
            !item.apiFramework                              ||
            item.apiFramework.toUpperCase() !== 'VPAID'*/
        ) { return; }

        item.implName = ( item.type !== 'text/javascript' && item.type !== 'application/javascript') ? 'flash' : 'html5';

        return {
            mimeType:    item.type,
            description: ['linear? ', item.implName, '-powered VPAID ad unit'].join(''),
            item:        item,
            builder:     AdUnitBuilder
        };
    }



    VAST.handlers.AdUnit = AdUnitHdlr;

})();
